<template>
    <div class="pre-loader--wrapper" :style="{ 'min-height': wrapperHeight }">
        <div :class="'pre-loader'" :style="[{ width: size }, { height: size }]">
            <div :class="className"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Preloader',
    props: {
        className: {
            String,
            default: 'pre-loader__circle'
        },
        size: {
            String,
            default: '80px'
        },
        wrapperHeight: {
            String,
            default: '200px'
        }
    },
    data() {
        return {}
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Preloader.vue